import { render } from "./HiLoading.vue?vue&type=template&id=15c58d6a&scoped=true"
import script from "./HiLoading.vue?vue&type=script&lang=js"
export * from "./HiLoading.vue?vue&type=script&lang=js"

import "./HiLoading.vue?vue&type=style&index=0&id=15c58d6a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c58d6a"]])

export default __exports__